import React, { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { FiArrowRight, FiX } from "react-icons/fi"
import "./style.css"
import MaskCPF from "../../../inc/Mask/cpf"
import MaskPhone from "../../../inc/Mask/telefone"
import updateLead from "../../../inc/Fx/updateLead"
import api from "../../../services/api"
import encryptClass from "../../../inc/Controllers/encrypt.class"
import { GlobalContext } from "../../../contexts/global"
import validateCpf from "../../../inc/Fx/validateCpf"
import validatePhone from "../../../inc/Fx/validatePhone"
import Alert from "../../Global/Alert"

const PopupTelemed = props => {
  const [client_cpf, set_client_cpf] = useState(
    sessionStorage.getItem("client_cpf") !== null
      ? sessionStorage.getItem("client_cpf")
      : ""
  )
  const [client_phone, set_client_phone] = useState(
    sessionStorage.getItem("client_phone") !== null
      ? sessionStorage.getItem("client_phone")
      : ""
  )

  const [cpfError, setCpfError] = useState("")
  const [isAlertOpen, setIsAlertOpen] = useState(false)

  let popupClassName = props.isOpen
    ? "site-popup-cpf popup-open"
    : "site-popup-cpf"

  const navigate = useNavigate()

  const close_popup = e => {
    e.preventDefault()
    props.toggle(false)
  }

  const { setPatientFound, setLoaderState } = useContext(GlobalContext)

  /**
   * Chama POST /telemedicina/resolve no backend.
   * @param {string} escClientCpf - CPF limpo (somente números)
   * @param {object} feegowData  - Dados do paciente vindos do Feegow (fallbacks)
   */
  const handleTelemedicinaConexa = async (escClientCpf, feegowData = {}) => {
    try {
      // Normaliza sexo do Feegow ("Masculino"/"Feminino") para "M"/"F"
      var genre = ""
      if (feegowData.sexo) {
        var s = feegowData.sexo.charAt(0).toUpperCase()
        genre = (s === "M" || s === "F") ? s : ""
      }

      // Body — CPF obrigatório, demais são fallbacks opcionais
      const body = {
        clientId: sessionStorage.getItem("client"),
        feegowPatientId: feegowData.id,
        cpf: escClientCpf,
        telefone: client_phone.replace(/\D/g, ""),
        ...(feegowData.nome && { clientName: feegowData.nome }),
        ...(feegowData.email && { clientEmail: feegowData.email }),
        ...(feegowData.nascimento && { clientBirthDate: feegowData.nascimento }),
        ...(genre && { clientGenre: genre }),
        isNewToFeegow: false
      }

      console.log("[DEBUG telemed] body enviado:", JSON.stringify(body))
      console.log("[DEBUG telemed] x-api-key:", process.env.REACT_APP_AGENT_API_KEY)

      const response = await api.post("/telemedicina/resolve", body)

      console.log("[DEBUG telemed] response:", response.data)

      const { success, content, message } = response.data

      if (!success) {
        throw new Error(content || "Erro ao gerar link de telemedicina")
      }

      const { webLink, appLink } = content

      if (sessionStorage.getItem("client")) {
        updateLead({ COMPLETE_DATE: new Date().toISOString() })
      }

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

      setLoaderState(false)

      if (isMobile && appLink) {
        window.location.href = appLink
      } else if (webLink) {
        window.open(webLink, "_blank")
        props.toggle(false)
      } else {
        throw new Error("Links de telemedicina não retornados")
      }
    } catch (error) {
      console.error("Erro ao acessar telemedicina Conexa:", error)
      console.log("[DEBUG telemed] error.response:", error.response && error.response.data)
      setLoaderState(false)

      // Mensagem amigável — usa a do backend se disponível
      const errorMsg = error.response && error.response.data && error.response.data.content
        ? error.response.data.content
        : "Não foi possível acessar a telemedicina no momento. Por favor, tente novamente mais tarde."

      setCpfError(errorMsg)
      setIsAlertOpen(true)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoaderState(true)

    if (!validateCpf(client_cpf)) {
      setCpfError("CPF inválido.")
      setIsAlertOpen(true)
      setLoaderState(false)
      return
    }

    const phoneError = validatePhone(client_phone)
    if (phoneError) {
      setCpfError(phoneError)
      setIsAlertOpen(true)
      setLoaderState(false)
      return
    }

    const escClientCpf = client_cpf.replace(/\D/g, "")

    // Fetch Patient no Feegow
    try {
      const feegowResp = await api.post("/patient", {
        client_cpf: escClientCpf
      })

      const { success, content } = feegowResp.data

      if (success) {
        // Paciente ENCONTRADO no Feegow
        let patientFound = encryptClass.hash(
          JSON.stringify({
            id: content.id,
            nome: content.nome,
            email: content.email[0],
            nasc: content.nascimento,
            sexo: content.sexo
          })
        )

        sessionStorage.removeItem("client_name")
        sessionStorage.removeItem("client_email")
        sessionStorage.removeItem("client_nascimento")
        sessionStorage.removeItem("client_genre")
        sessionStorage.removeItem("patient")

        setPatientFound(patientFound)
        sessionStorage.setItem("typeTabelaId", content.tabela_id)
        sessionStorage.setItem("patientFound", patientFound)

        // Chama telemedicina Conexa com dados do Feegow como fallback
        await handleTelemedicinaConexa(escClientCpf, {
          id: content.id,
          nome: content.nome,
          email: content.email && content.email[0],
          nascimento: content.nascimento,
          sexo: content.sexo
        })
      } else {
        // Paciente NÃO ENCONTRADO → redireciona para cadastro
        setPatientFound(null)
        sessionStorage.removeItem("patientFound")

        // Garante que CPF e telefone estão salvos (não depende do onBlur)
        sessionStorage.setItem("client_cpf", client_cpf)
        sessionStorage.setItem("client_phone", client_phone)

        // Seta convênio como particular para o Cadastro funcionar
        // (o fluxo normal passa por /convenio que seta isso)
        sessionStorage.setItem("convenio", "true")
        sessionStorage.setItem("tabelaId", "2") 

        setLoaderState(false)
        sessionStorage.setItem("origem_cadastro", "telemedicina")
        navigate("/cadastro", { state: { origem: "telemedicina" } })
      }
    } catch (error) {
      console.error("Erro ao buscar paciente no Feegow:", error)
      setLoaderState(false)
      setCpfError("Erro ao verificar cadastro. Por favor, tente novamente.")
      setIsAlertOpen(true)
    }
  }

  return (
    <section className={popupClassName}>
      <div className="glass" onClick={close_popup}></div>
      <div className="content">
        <span className="close-button" onClick={close_popup}>
          <FiX size={44} />
        </span>
        <h2 className="popup-title">
          Por favor, <br /> informe os dados do{" "}
          <strong>paciente para telemedicina</strong>:
        </h2>
        <form onSubmit={handleSubmit} className="form-popup">
          <div className="popup-form-content">
            <div className="input-text" style={{ marginBottom: 40 }}>
              <label htmlFor="client_cpf_telemed">
                <p>CPF</p>
                <input
                  type="text"
                  inputMode="numeric"
                  name="client_cpf"
                  id="client_cpf_telemed"
                  autoComplete="off"
                  value={client_cpf}
                  placeholder="Digite seu CPF"
                  maxLength={14}
                  required
                  onBlur={() => sessionStorage.setItem("client_cpf", client_cpf)}
                  onChange={e => set_client_cpf(MaskCPF(e.target.value))}
                />
              </label>
            </div>
            <div className="input-text">
              <label htmlFor="client_phone_telemed">
                <p>Celular</p>
                <input
                  type="text"
                  inputMode="numeric"
                  name="client_phone"
                  id="client_phone_telemed"
                  value={client_phone}
                  placeholder="DDD + Celular"
                  maxLength={15}
                  onBlur={() => sessionStorage.setItem("client_phone", client_phone)}
                  required
                  onChange={e => set_client_phone(MaskPhone(e.target.value))}
                />
              </label>
            </div>
          </div>

          <p className="popup-warning">
            Certifique-se de utilizar o CPF e telefone cadastrados em nossos sistemas.
            Se você não lembra ou deseja mudar o telefone, entre em contato com nosso{" "}
            <a
              href="https://wa.me/552126665808?text=Quero falar sobre meu CPF/telefone cadastrado nos seus sistemas"
              target="_blank"
              rel="noopener noreferrer"
            >
              atendimento ao cliente
            </a>
            .
          </p>

          <div className="input-submit lightblue-submit">
            <button type="submit">
              Iniciar Telemedicina
              <FiArrowRight />
            </button>
          </div>
        </form>
      </div>
      <Alert isOpen={isAlertOpen} onClose={setIsAlertOpen} title="Atenção!">
        <p>{cpfError}</p>
      </Alert>
    </section>
  )
}

export default PopupTelemed
